import type { EditorPluginCreator } from './../ricos-types';
import { TextColorPicker } from './/TextColorPicker';

import { backgroundColorConverter, textColorConverter } from './color-converter';
import { getTextColorTextButtons, getTextHighlightTextButtons } from './getTextButtons';
import { tiptapColorBackgroundExtension } from './tiptap-background';
import { tiptapColorForegroundExtension } from './tiptap-foreground';
import type { TextColorPluginEditorConfig, TextHighlightPluginEditorConfig } from './types';
import { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE } from './types';

export const pluginTextColor: EditorPluginCreator<
  TextColorPluginEditorConfig,
  { TextColorPicker: typeof TextColorPicker }
> = (config = {}) => {
  return {
    config,
    pmMarkConverters: [textColorConverter],
    pmNodeConverters: [],
    type: TEXT_COLOR_TYPE,
    // @todo: next-major: move tiptapColorBackgroundExtension to pluginTextHighlight
    tiptapExtensions: [tiptapColorForegroundExtension],
    textButtons: getTextColorTextButtons(config),
    __exports: {
      TextColorPicker,
    },
  };
};

export const pluginTextHighlight: EditorPluginCreator<TextHighlightPluginEditorConfig> = (
  config = {}
) => {
  return {
    config,
    pmMarkConverters: [backgroundColorConverter],
    pmNodeConverters: [],
    type: TEXT_HIGHLIGHT_TYPE,
    tiptapExtensions: [tiptapColorBackgroundExtension],
    textButtons: getTextHighlightTextButtons(config),
  };
};
